import { Alert, FormControl, InputLabel, MenuItem, Select, Snackbar, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./updateprofile.module.css";
import { useForm, Controller } from "react-hook-form";
import withCustomerAuth from "../../components/withCustomerAuth";
import { authData } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../../components/sideBar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { usePlacesWidget } from "react-google-autocomplete";
import { StorageGetItem, StorageSetItem } from "../../../admin/components/StorageComp";

function MyProfile() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
      post_code: "",
      registered_company: "",
      company_shipping: "",
      company_name: "",
    },
  });
  const [isRegCompany, setIsRegCompany] = useState({});

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);

      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      place.address_components.forEach((item) => {
        if (item.types.indexOf("postal_code") > -1) {
          setValue("post_code", item.long_name);
        }
      });
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: "GB" }
    },
  });

  useEffect(() => {
    setValue("name", authData()?.customer?.name);
    setValue("email", authData()?.customer?.email);
    setValue("phone", authData()?.customer?.phone);
    setValue("address", authData()?.customer?.address);
    setValue("post_code", authData()?.customer?.post_code);

    setIsRegCompany(authData()?.customer?.registered_company);
    setValue("registered_company", authData()?.customer?.registered_company);
    if (authData()?.customer?.registered_company === "Yes") {
      setValue("company_shipping", authData()?.customer?.company_shipping);
      setValue("company_name", authData()?.customer?.company_name);
    }
  }, [setValue]);

  const onSubmit = (data) => {
    setLoading(true);

    let postData = {
      address: data?.address,
      email: data?.email,
      name: data?.name,
      phone: data?.phone,
      post_code: data?.post_code,
      registered_company: data?.registered_company,
    };

    if (data?.registered_company === "Yes") {
      postData = { ...postData, company_name: data?.company_name, company_shipping: data?.company_shipping };
    }

    return axios.post(process.env.REACT_APP_API_URL + "v1/customer/update-profile", postData, {
      headers: {
        Authorization: `Bearer ${authData()?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarType("success");
        setSnackbarMessage(response.data.message);

        let resData = response.data.data;
        let authData = StorageGetItem("bookAuthData");
        authData = JSON.parse(authData);
        authData = { ...authData, customer: resData };
        StorageSetItem("bookAuthData", authData, 24 * 60 * 60 * 1000);
        setTimeout(() => {
          navigate("/customer/profile");
        }, 2500);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>Change Password</p>
              </div>
              <div className={`${styles.UserProDe}`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${styles.FormRow}`}>
                      <div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("name", { required: "Please enter fullname" })}
                          render={({ field }) => (<TextField {...field} label="Full Name*" variant="outlined" />)}
                        />
                        {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
                      </div>
                      <div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("email", {
                            required: "This field is Required",
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: "Invalid email address",
                            },
                          })}
                          render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" disabled={true} />)}
                        />
                        {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
                      </div>
                    </div>
                    <div className={`${styles.FormRow}`}>
                      <div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("phone", { required: "This field is Required" })}
                          render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
                        />
                        {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
                      </div>
                      <div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("address", { required: "This field is Required" })}
                          render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={ref} placeholder="" />)}
                        />
                        {errors.address && (<span className={`ErrorM`}>{errors?.address?.message}</span>)}
                      </div>
                    </div>
                    <div className={`${styles.FormRow}`}>
                      <div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("post_code", { required: "This field is Required" })}
                          render={({ field }) => (<TextField  {...field} label="Post Code*" variant="outlined" />)}
                        />
                        {errors.post_code && (<span className={`ErrorM`}>{errors?.post_code?.message}</span>)}
                      </div>
                      <div className={`FormHalfGroup`}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Do you have a Registered Company?*</InputLabel>
                          <Controller
                            control={control}
                            {...register("registered_company", { required: "This field is Required" })}
                            render={({ field }) => (<Select
                              {...field}
                              label="Do you have a Registered Company?*"
                              onChange={(e) => {
                                field.onChange(e);
                                setIsRegCompany(e.target.value);
                              }}
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>)}
                          />
                        </FormControl>
                        {errors.registered_company && (<span className={`ErrorM`}>{errors?.registered_company?.message}</span>)}
                      </div>
                    </div>

                    <div className={`${styles.FormRow}`}>
                      {isRegCompany === "Yes" && (<div className={`FormHalfGroup`}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">If Yes, are you shipping the goods in the name of the company?*</InputLabel>
                          <Controller
                            control={control}
                            {...register("company_shipping", { required: "This field is Required" })}
                            render={({ field }) => (<Select
                              {...field}
                              label="If Yes, are you shipping the goods in the name of the company?*"
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>)}
                          />
                        </FormControl>
                        {errors.company_shipping && (<span className={`ErrorM`}>{errors?.company_shipping?.message}</span>)}
                      </div>)}
                      {isRegCompany === "Yes" && (<div className={`FormHalfGroup`}>
                        <Controller
                          control={control}
                          {...register("company_name", { required: "This field is Required" })}
                          render={({ field }) => (<TextField {...field} label="Registered Company Name*" variant="outlined" />)}
                        />
                        {errors.company_name && (<span className={`ErrorM`}>{errors?.company_name?.message}</span>)}
                      </div>)}
                    </div>
                    <button type="submit" className={`${styles.LoginBU}`}>
                      <span>Update Profile</span>
                    </button>
                  </form>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default withCustomerAuth(MyProfile);